import { render, staticRenderFns } from "./pwdReset.vue?vue&type=template&id=d76514fc&scoped=true&"
import script from "./pwdReset.vue?vue&type=script&lang=js&"
export * from "./pwdReset.vue?vue&type=script&lang=js&"
import style0 from "./pwdReset.vue?vue&type=style&index=0&id=d76514fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76514fc",
  null
  
)

export default component.exports